import AdminTitle from './adminTitle'

export default {
    install: function(Vue) {
        Vue.component('AdminTitle',AdminTitle)
    }
}